<mat-toolbar id="headset" class="headset">

  <app-breadcrumbs [start]="route" [title]="title"></app-breadcrumbs>

  <span class="flex-spacer"></span>
  <span *ngIf="addButtonName">
      <button mat-raised-button color="primary"
              (click)="onAddClick()">
        <span class="hide-mobile">{{ addButtonName }} </span><mat-icon
        svgIcon="content:ic_add_24px"></mat-icon>
      </button>
  </span>
  <ng-content select="button">
  </ng-content>
</mat-toolbar>
